module.exports = __webpack_public_path__ + "fd5a608a/img/45000000-7.dd3ac6fe.png";